<template>
  <div class="approvalSend">
    <ld-header>订单送审</ld-header>

    <div class="current pad8">
      <van-row
        type="flex"
        align="center"
        class="pad8"
      >
        <van-col
          span="19"
          class="font-bold font20"
        >
          审批名称: {{ currOrder.vipSpgzGetInfo.gzmc }}
        </van-col>
        <van-col
          span="5"
          class="text-right"
        >
          <van-checkbox
            v-model="approverAllcheck"
            v-check-all="approverAllcheck"
            check-data="currOrder.vipSpgzGetInfo.gznr"
            nest-array="empList"
            check-key="checked"
          >
            全选
          </van-checkbox>
        </van-col>
      </van-row>
      <van-row
        v-for="spgz in currOrder.vipSpgzGetInfo.gznr"
        :key="spgz.level"
        type="flex"
        align="center"
      >
        <van-col
          class="bg-white mt5 pad8"
          :span="24"
        >
          <div>审批级别 {{ spgz.level }} <span v-show="spgz.empList[0].jblx==1">(仅确认)</span></div>

          <van-row
            class="font-bold mt5"
            v-for="emp in spgz.empList"
            :key="emp.empId"
          >
            <van-col
              class="van-ellipsis"
              :span="19"
            >
              {{ emp.empNo }} {{ emp.empName }} {{ '(' + emp.vipdeptName + ')' }}
            </van-col>
            <van-col :span="4">
              <van-checkbox
                class="fr"
                v-model="emp.checked"
              />
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </div>

    <img
      width="100%"
      height="3"
      src="~/Assets/images/order/splitLine.png"
    >

    <van-cell-group
      class="approval-content pad8"
      v-if="waitApplyList.length > 0"
    >
      <div slot="title">
        <span>关联其他订单批量送审</span>
        <van-checkbox
          class="fr"
          v-model="allChecked"
          v-check-all="allChecked"
          check-data="waitApplyList"
          nest-array="totalOrderList"
          check-key="checked"
        >
          全选
        </van-checkbox>
      </div>

      <van-collapse
        v-model="activeName"
        v-for="(li, index) in waitApplyList"
        :key="index"
      >
        <van-collapse-item
          :name="item.id"
          v-for="item in li.totalOrderList"
          :key="item.id"
        >
          <van-row
            slot="title"
            gutter="10"
            type="flex"
            align="center"
          >
            <van-col :span="3">
              <van-checkbox v-model="item.checked" />
            </van-col>

            <!-- 行程信息 -->
            <van-col :span="21">
              <!-- 产品类型 -->
              <div class="font-bold font16">
                <!--正常单-->
                <span v-if="item.orderType==11001 || item.orderType==11004 || item.orderType==11009 || item.orderType==11007">
                  <div
                    v-show="item.tripType == 2"
                    class="text-icon white bg-red"
                  >
                    私
                  </div>
                  <span
                    class="font_ico"
                    v-if="item.nFlightNo == 1"
                  >抢</span>
                  {{ item.voyageZh }}
                  <span
                    v-if="item.orderType == 11004"
                    class="font12"
                  >&nbsp;{{ $t('A015','国际') }}</span>
                </span>
                <!--退票单-->
                <span v-if="item.orderType==11002 || item.orderType==11008 || item.orderType==11010">
                  <div
                    v-show="item.tripType == 2"
                    class="text-icon white bg-red"
                  >
                    私
                  </div>

                  {{ item.voyageZh }}
                </span>
                <!--改签单-->
                <span v-if="item.orderType==11003 || item.orderType==11011">
                  <div
                    v-show="item.tripType == 2"
                    class="text-icon white bg-red"
                  >
                    私
                  </div>
                  {{ item.voyageZh }}
                </span>
                <!--用车-->
                <span v-if="item.orderType==11018">
                  {{ item.voyageZh }} {{ item.cabinName }}
                </span>

                <!-- 签证 -->
                <span v-if="item.orderType == 11023">
                  {{ item.xcdd }}
                </span>
              </div>

              <!--行程详细信息-->
              <div
                class="font12"
                v-if="item.orderType==11001 || item.orderType==11004 || item.orderType==11009 || item.orderType==11007 || item.orderType==11002 || item.orderType==11008 || item.orderType==11010 || item.orderType==11003 || item.orderType==11011"
              >
                <span v-if="item.orderType==11001 || item.orderType==11004 || item.orderType==11009 || item.orderType==11007 || item.orderType==11002 || item.orderType==11008 || item.orderType==11010">{{ item.departTime }} | {{ item.flightNo }}</span>
                <span v-if="item.orderType==11003 || item.orderType==11011">
                  <span v-show="item.productImage == 1">{{ $t('F040') }}：</span>
                  <span v-show="item.productImage == 3">{{ $t('F041') }}：</span>
                  <span>{{ item.departTime }} | {{ item.flightNo }}</span>
                </span>
              </div>
              <div
                slot="info"
                v-if="item.orderType==11018 && (item.productImage==1 || item.productImage==2)"
              >
                <div class="tkedit_black tkcbin_font24">
                  {{ item.departTime |filterDateForm }} &nbsp;&nbsp;<span class="">{{ $t('E017','共') }}{{ item.nights }}天</span>
                </div>
              </div>
              <div
                slot="info"
                v-if="item.orderType==11018 && (item.productImage==1 || item.productImage==2)"
              >
                <div class="gray">
                  {{ item.flightNo }}
                </div>
              </div>
              <div
                slot="info"
                v-if="item.orderType==11018 && (item.productImage==4 || item.productImage==5)"
              >
                <div class="tkedit_black tkcbin_font24">
                  <span class="iconfont" />{{ item.departTime |filterDateForm }}
                </div>
              </div>
              <div
                slot="info"
                v-if="item.orderType==11018 && (item.productImage==4 || item.productImage==5)"
              >
                <span class="iconfont icon-qidian1 blue" />
                {{ item.flightNo }}
              </div>
              <div
                slot="info"
                v-if="item.orderType==11018 && (item.productImage==4 || item.productImage==5)&&item.nFlightNo"
              >
                <span
                  class="iconfont icon-zhongdian"
                  style="color: #f0ad4e;"
                />
                {{ item.nFlightNo }}
              </div>

              <div
                class="font12"
                v-if="item.orderType == 11023"
              >
                {{ item.departTime }} {{ item.flightNo }}
              </div>

              <!-- 下单人 -->
              <div class="gray font12">
                {{ item.psgName }}
              </div>
            </van-col>
          </van-row>

          <!-- 价格 -->
          <div
            slot="right-icon"
            class="red"
          >
            <!--正常-->
            <span v-if="item.orderType==11001 || item.orderType==11004 || item.orderType==11009 || item.orderType==11007">
              ￥<big>{{ Number(item.subtotal || 0) + Number(item.bxPrice || 0) }}</big>
            </span>
            <!--退单-->
            <span v-if="item.orderType==11002 || item.orderType==11008 || item.orderType==11010">
              应退：￥<big>{{ isNaN(item.subtotal + Number(item.bxPrice))?"待确定":(item.subtotal + Number(item.bxPrice)) }}</big>
            </span>
            <!--改签单-->
            <span v-if="item.orderType==11003 || item.orderType==11011">
              ￥<big>{{ isNaN(item.subtotal + Number(item.bxPrice))?"待确定":(item.subtotal + Number(item.bxPrice)) }}</big>
            </span>
            <!--用车-->
            <span v-if="item.orderType==11018">￥{{ item.subtotal }}</span>
          </div>


          <!-- 审批规则 -->
          <div
            class="gray font12"
            v-for="spgz in li.vipSpgzGetInfo.gznr"
            :key="spgz.level"
          >
            <span>审批级别：{{ spgz.level }}</span><br>
            <span
              v-for="emp in spgz.empList"
              :key="emp.empId"
            >
              {{ emp.empNo }} {{ emp.empName }}
              <span v-show="emp.vipdeptName">
                {{ '(' + emp.vipdeptName + ')' }}
              </span>
            </span>
          </div>
        </van-collapse-item>
      </van-collapse>
    </van-cell-group>

    <div
      class="text-center mt5"
      v-else
    >
      <img src="~/Assets/images/order/listNull.png">
      <div class="gray">
        无其他关联订单<br>预订其他订单后可关联批量送审
      </div>
    </div>

    <van-field
      v-model="sentRemark"
      rows="2"
      :required="sentRemarkFlag"
      autosize
      label="送审备注"
      type="textarea"
      maxlength="200"
      :placeholder="sentRemarkFlag?'请填写送审信息':'请填写送审信息（选填）'"
      show-word-limit
      style="margin-top: 40px;"
    />

    <ld-uploader v-if="this.$route.query.orderId" :orderId="this.$route.query.orderId" :glywlx="this.$route.query.orderType" :cjlx="2" :showFinished="false"/>


    <!--提交申请-->
    <ld-tabbar
      class="pad8"
      style="height: auto;"
    >
      <ld-button
        main
        round
        @click="toSend"
      >
        {{ $t('K230','提交送审') }}
      </ld-button>
    </ld-tabbar>
  </div>
</template>

<script>
import { Tag, Checkbox, CheckboxGroup, Collapse, CollapseItem, Cell, CellGroup, Field } from 'vant'
import { mapGetters } from 'vuex'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'

import ldUploader from 'Components/ldUploader'
import checkAll from 'Utils/check-all'

export default {
  directives: {
    checkAll
  },
  components: {
    [Tag.name]: Tag,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    ldButton,
    ldTabbar,
    ldUploader
  },
  data () {
    return {
      currOrder: {
        vipSpgzGetInfo: { gznr: [] }
      },
      waitApplyList: '1',
      approverAllcheck: false,
      sentRemarkFlag:false,
      allChecked: false,
      activeName: [],
      sentRemark: '',
    }
  },
  created () {
    if (this.$route.query.isCcsqd) {
      this.getApplyRuleId()
    } else {
      this.getApprovalList()
    }
  },
  methods: {
    // 获取关联订单
    async getApprovalList() {
      var params = {
        orderId: this.$route.query.orderId,
        orderType: this.$route.query.orderType,
        orderNo: this.$route.query.orderNo
      }

      let { data = [] } = await this.$api['approval/orderApproveList'](params)
      // 当前订单
      if(data.length > 0) this.currOrder = data[0]
      // 除了第一个订单后面的都是关联订单
      this.waitApplyList = data.splice(1)

      this.isAllCheckApprover()
    },
    async getApplyRuleId() {
      var spgzId = this.$route.query.gzid || this.$route.query.spgzId
      var againApp = this.$route.query.againApp
      if(againApp) {
        this.againApp = againApp
      }
      // 判断是否  从路由里 获取 规则id
      if(spgzId) {
        this.getApprovaDetail(spgzId)
      } else {
        var bookEmpId = this.userInfo.empInfo.empId
        var params = {
          bookEmpId: bookEmpId,
          djlx: this.$route.query.orderType //单据类型
        }
        let { data = {} } = await this.$api['approval/vipSpkzNeedApproval'](params)
        this.getApprovaDetail(data.spgzId)
      }
    },
    //获取审批规则详情
    async getApprovaDetail(spgzId) {
      if(!spgzId) return
      var params = {
        spgzId
      }
      let { data = {} } = await this.$api['approval/vipSpgzGetInfo'](params)
      this.currOrder.vipSpgzGetInfo.gznr = data.gznr
      this.isAllCheckApprover()
    },
    // 是否默认全选审批人  value1：1是 0否
    // async isAllCheckApprover () {
    //   let { data = {} } = await this.$api['common/getParameter']({paramNo: 20017})
    //   let value1 = data.value1
    //   if (value1 == 1) this.approverAllcheck = true
    // },
    async isAllCheckApprover () {
      let { data = {} } = await this.$api['common/getParameter']({paramNo: 20031})
      let value1 = data.value1
      if (value1 == 1) this.sentRemarkFlag = true
    },
    //送审
    async toSend() {
      var sendlist = [{
        orderId: this.currOrder.totalOrderList[0].id,
        orderType: this.currOrder.totalOrderList[0].orderType,
        orderNo: this.currOrder.totalOrderList[0].orderNo,
        spgzId: this.currOrder.vipSpgzGetInfo.gzid,
        againApp: this.againApp
      }]

      this.waitApplyList.forEach((item) => {
        var gzid = item.vipSpgzGetInfo.gzid
        item.totalOrderList.forEach((item) => {
          if (item.checked) {
            sendlist.push({
              orderId: item.id,
              orderType: item.orderType,
              orderNo: item.orderNo,
              spgzId: gzid,
              againApp: this.againApp
            })
          }
        })
      })

      var vipBpmPersonnels = [],
        checkEmp = {} // 检查每一个差标等级都有员工
      this.currOrder.vipSpgzGetInfo.gznr.forEach((item) => {
        var level = item.level

        if (!checkEmp[level]) checkEmp[level] = []
        item.empList.forEach((emp) => {
          if (emp.checked) {
            checkEmp[level].push(emp.empId)

            vipBpmPersonnels.push({
              empName: emp.empName,
              empId: emp.empId,
              gzid: this.currOrder.vipSpgzGetInfo.gzid,
              spjb: level,
              jblx: emp.jblx || 0
            })
          }
        })
      })

      for (var rank in checkEmp) {
        if (checkEmp[rank].length == 0) {
          this.$dialog({message: '同审批级别最少一个审批人！'})
          return false
        }
      }


      var params = {
        sendApps: [],
        orderId: '',
        orderType: '',
        spgzId: '',
        sentRemark: this.sentRemark,
        vipBpmPersonnels: vipBpmPersonnels
      }
      console.log(!params.sentRemark);
      console.log(this.sentRemarkFlag);
      if (!params.sentRemark && this.sentRemarkFlag) {
        this.$dialog({message: '请填写送审备注！'})
        return
      }
      if (sendlist.length > 1) {
        params.sendApps = sendlist
      } else {
        params.orderId = sendlist[0].orderId
        params.orderType = sendlist[0].orderType
        params.orderNo = sendlist[0].orderNo
        params.spgzId = sendlist[0].spgzId
        params.againApp = sendlist[0].againApp
      }

      let res = await this.$api['approval/vipBpmSendAppNew'](params)

      this.$dialog({message: '送审成功！'}).then(() => {
        this.$store.commit('SET_ORDERLISTPARAMS', {
          findType: 1
        })
        this.$router.push({path: '/allorder'})
      })
    },
  },
  computed: {
    ...mapGetters({
      userInfo:'userInfo'
    })
  },
  filters: {
    //  过滤 日期格式  2017-03-06 12:00:32   转换为   03-06 12:00
    //  或者  日期 格式 是    03-06   12:00:32    转换为   03-06 12:00
    filterDateForm:function(val){
      if(val){
        var arr = val.split(' ')
        var str1 = arr[0].length == 10?arr[0].substr(5,arr[0].length):arr[0]
        var arr2 =arr[1].split(':')
        var str2 = arr2[0] + ':' +  arr2[1]
        return str1 + ' ' + str2
      }
    }
  }
}
</script>

<style lang="less">
@import "~Assets/styles/business.less";
.approvalSend {
  padding-bottom: 62px;

  .pad8 {
    padding: 8px;
  }
  .mt5 {
    margin-top: 5px;
  }

  .cicle {
    width: 7px;
    height: 7px;
    margin-right: 10px;
    border-radius: 50%;
  }

  .approval-content {
    padding-bottom: 50px;

    &.van-cell-group {
      background-color: inherit;
    }

    .van-collapse-item__content {
      padding-top: 10px;
      padding-left: 45px;
    }
  }

}
</style>
